module.exports = __webpack_public_path__ + "static/img/logo-6.279c0873.png";